import { render } from "./UsersList.vue?vue&type=template&id=7dd06f16&ts=true"
import script from "./UsersList.vue?vue&type=script&lang=ts"
export * from "./UsersList.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__